import React, { useCallback, useMemo, useDeferredValue } from 'react'
import { useSelector, useDispatch, shallowEqual } from 'react-redux'

import * as gameActions from '../game.actions'
import * as gameSelectors from '../game.selectors'
import * as selectors from './screens.selectors'

/**
 *  Container for screens. Manage all screens presentation.
 */
const ScreensContainer = () => {
  const dispatch = useDispatch()
  
  // Redux selectors optimizados
  const screenData = useSelector(
    (state) => ({
      components: gameSelectors.getModuleComponents(state),
      screens: selectors.getScreens(state),
    }),
    shallowEqual
  )

  const { components, screens } = screenData

  // Usar useDeferredValue para diferir la renderización de screens no críticas
  const deferredScreens = useDeferredValue(screens)

  // Action creators
  const setCursorPosition = useCallback((event) => {
    dispatch(gameActions.setCursorPosition(event))
  }, [dispatch])

  /**
   *  Render each screen available
   */
  const renderScreen = useCallback((screen) => {
    const Screen = components[screen.component]

    if (!Screen) {
      throw new Error(`${screen.component} cannot be found. \\
        Check if the module has registered it.`)
    }

    return <Screen key={screen.id} {...screen.props} />
  }, [components])

  const handleClick = useCallback((e) => {
    setCursorPosition(e)
  }, [setCursorPosition])

  const handleTouchStart = useCallback((e) => {
    let touch = null
    if (e.targetTouches.length >= 1) touch = e.targetTouches.item(0)
    else touch = e.touches.item(0)

    setCursorPosition(touch)
  }, [setCursorPosition])

  // Memoized event handlers object
  const events = useMemo(
    () => ({
      onClick: handleClick,
      onTouchStart: handleTouchStart,
    }),
    [handleClick, handleTouchStart]
  )

  // Renderizado condicional al final
  if (deferredScreens.length === 0) {
    return null
  }

  return (
    <div className={'screens-container'} {...events}>
      {deferredScreens.map((screen) => renderScreen(screen))}
    </div>
  )
}

export default React.memo(ScreensContainer)
